import { useContext } from 'react';
import invariant from 'tiny-invariant';

import { ThemeContext } from './internal/ThemeContext';
import type { Theme } from './types';

// Returns the resolved theme value ('default' | 'dark'), never 'system'
export const useThemeValue = (): Theme => {
  const { theme } = useContext(ThemeContext);
  invariant(theme, 'useThemeValue must be used within a ThemeProvider');
  return theme;
};
